import { handleLoginFailure, handleLoginSuccess } from "../../Routes/authUtils";
import { fetchPermissions } from "../../permissionsSlice";
import { LOGIN_API } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";

import 'react-toastify/dist/ReactToastify.css';
import { showPasswordWarning } from "../passwordWarningSlice";

export const loginUser = (values, navigate, setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    const requestData = {
      userName: values.email,
      password: values.password,
    };

    const response = await determineBaseUrlAndPerformApiCall(`${LOGIN_API}`, 'POST', requestData);

    const passwordWarning = response?.headers?.get?.('X-Password-Warning');

    if (passwordWarning === "PASSWORD_EXPIRY_SOON" ||passwordWarning ==="PASSWORD_EXPIRED" && response ) {
      localStorage.setItem('userId', response.userId);
      localStorage.setItem('token', response.accessToken);
      dispatch(showPasswordWarning({ response, navigate, setLoading }));
      return;
    }
    
    if (response.accessToken && passwordWarning === undefined ) {
      handleLoginSuccess(response, dispatch, setLoading, navigate);
    } else {
      handleLoginFailure(response?.error?.message, setLoading);
    }
  } catch (error) {
    handleLoginFailure(error?.response?.data?.error?.message, setLoading);
  }
};
